import React from "react";
import { object, func, string } from "prop-types";
import { connect } from "react-redux";
import { LoadMoreCollectionStories } from "@quintype/components";
import get from "lodash/get";

import Headline from "../../atoms/headline";
import MoreCollectionStories from "../more-collection-stories";

import { setLoading } from "../../helper/actions";

import "./loadMoreStoryMixedCollection.m.css";

const NO_OF_ITEMS_LOAD = 12;

const LoadMoreStoryMixedCollection = ({ collection, setLoading, publisherName }) => {
  if (!(collection && collection.items)) {
    return null;
  }

  const storyList = collection.items.filter((item) => item.type === "story").map((item) => item.story);

  if (!storyList.length) {
    return null;
  }

  return (
    <div styleName="wrapper" className="container">
      <Headline text={collection.name} headerType={9} />

      {collection.summary && <div styleName="summary">{collection.summary}</div>}

      <LoadMoreCollectionStories
        template={(e) => MoreCollectionStories(e, NO_OF_ITEMS_LOAD, setLoading, publisherName)}
        collectionSlug={collection.slug}
        data={{ stories: [...storyList] }}
        numStoriesToLoad={NO_OF_ITEMS_LOAD}
        params={{ "item-type": "story" }}
      />
    </div>
  );
};

LoadMoreStoryMixedCollection.propTypes = {
  collection: object.isRequired,
  setLoading: func,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

const mapDispatchToProps = (dispatch) => ({
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoadMoreStoryMixedCollection);
